import T from '../types';
import isEqual from 'lodash/isEqual';
import getHeatmapRequest from '../helpers/getHeatmapRequest';
import { prepareHeatmap } from '../helpers/prepareHeatmap';
import checkAjaxError from '@ott/helper-check-ajax-error';

let firstRequestParams;
let secondRequestParams;

let firstRequestData;
let secondRequestData;

const MAX_DEALS_INTERVAL_DAYS = 365;

function setCache(isSecondRequest, params, data) {
  if (isSecondRequest) {
    secondRequestParams = params;
    secondRequestData = data;
  } else {
    firstRequestParams = params;
    firstRequestData = data;
  }
}

async function getRequest(params) {
  try {
    const { body } = await getHeatmapRequest(params);

    if (!Array.isArray(body)) {
      return Promise.reject(body);
    }

    return body;
  } catch (err) {
    return Promise.reject(checkAjaxError(err));
  }
}

export default function updateHeatmap(
  isRT,
  fromCity,
  toCity,
  toDate,
  fromDate,
  referrer,
  isDirectFlights
) {
  return function (dispatch) {
    return dispatch({
      promise: async () => {
        const isSecondRequest = isRT && toDate && !fromDate;

        if (isRT == null || !fromCity || !toCity) {
          setCache(isSecondRequest, undefined, undefined);

          return;
        }

        const currentParams = [
          isRT,
          fromCity,
          toCity,
          isDirectFlights,
          isSecondRequest ? toDate : undefined,
        ];

        if (isEqual(isSecondRequest ? secondRequestParams : firstRequestParams, currentParams)) {
          // eslint-disable-next-line consistent-return
          return isSecondRequest ? secondRequestData : firstRequestData;
        }

        // if GET_HEATMAP_FAIL
        setCache(isSecondRequest, undefined, undefined);

        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth();
        const date = now.getDate();

        const today = new Date(year, month, date);
        let lastDate = new Date(year, month, date);
        lastDate = new Date(lastDate.setDate(lastDate.getDate() + MAX_DEALS_INTERVAL_DAYS));

        const params = isSecondRequest
          ? {
              isRT,
              fromCity,
              toCity,
              departure_date_from: today,
              departure_date_to: toDate,
              departure_or_return_date: toDate,
              return_date_from: toDate,
              return_date_to: lastDate,
              noPricing: 'true',
              referrer,
            }
          : {
              isRT,
              fromCity,
              toCity,
              departure_date_from: today,
              departure_date_to: lastDate,
              noPricing: 'true',
              referrer,
            };

        if (isDirectFlights) {
          params.direct_flights = true;
        }

        try {
          const result = await getRequest(params);
          const requestData = prepareHeatmap(result, params.departure_or_return_date);
          setCache(isSecondRequest, currentParams, requestData);

          // eslint-disable-next-line consistent-return
          return requestData;
        } catch (error) {
          // eslint-disable-next-line consistent-return
          return Promise.reject(error);
        }
      },
      types: [T.GET_HEATMAP, T.GET_HEATMAP_SUCCESS, T.GET_HEATMAP_FAIL],
    });
  };
}
